module.exports = __webpack_public_path__ + "static/media/transfer_horiz_24px.b5520599.svg";